import style from './style.module.scss'
import {Header} from "../../components/header"
import {ImportantInfoBanner} from "../../components/home/important-info-banner";
import {Service} from "../../components/home/service";
import {Team} from "../../components/home/team";
import {AboutUs} from "../../components/home/about-us";
import {Footer} from "../../components/footer";
import {Popup} from "../../components/popup";
import {useEffect, useState} from "react";
import {News} from "../../components/home/news";

const ACTIVE_HOLIDAY = true;
const HOLIDAY = {
    id: "summer-holiday-2026",
    endDate: new Date(2026, 7, 7, 23, 59, 59, 999),
};

export const Home = () => {
    const [isHoliday, setIsHoliday] = useState(false);
    const [hasHolidayEnded, setHolidayEnded] = useState(false);

    useEffect(() => {
        const holidayHasEnded = new Date() > HOLIDAY.endDate;

        const acceptedHolidayId = localStorage.getItem(
            "acceptedHolidayPopup"
        );

        const currentHolidayWasAccepted =
            acceptedHolidayId === HOLIDAY.id;

        setHolidayEnded(holidayHasEnded);
        setIsHoliday(
            ACTIVE_HOLIDAY &&
            !holidayHasEnded &&
            !currentHolidayWasAccepted
        );
    }, []);

    function holidayPopup() {
        localStorage.setItem(
            "acceptedHolidayPopup",
            HOLIDAY.id
        );
    }

    return (
        <div className={style.home_section}>
            <Header/>

            {isHoliday && ACTIVE_HOLIDAY && !hasHolidayEnded && (
                <Popup
                    title="Urlaub"
                    message="Wir sind vom 27.07.2026 bis zum 07.08.2026 im Urlaub."
                    isShown={isHoliday}
                    action={holidayPopup}
                />
            )}

            {ACTIVE_HOLIDAY && !hasHolidayEnded && (
                <>
                    <div
                        className={style.home_holiday_info_section}
                        role="status"
                        aria-label="Information zum Betriebsurlaub"
                    >
                        <div
                            className={style.home_holiday_info_icon}
                            aria-hidden="true"
                        >
                            ☀
                        </div>

                        <div className={style.home_holiday_info_content}>
                            <strong>
                                Betriebsurlaub vom 27.07. bis 07.08.2026
                            </strong>

                            <span>
                        Ab Montag, dem 10.08.2026, sind wir wieder für Sie da.
                    </span>
                        </div>
                    </div>
                </>
            )}

            <ImportantInfoBanner/>

            <h1>Karl Räke Kraftfahrzeuge e.K. - Kfz Werkstatt Hohenhameln</h1>

            <AboutUs/>

            <Team/>

            <Service/>

            <News/>

            <Footer/>
        </div>
    )
}